import Landing from './landing/[...path]'
export { getServerSideProps } from './landing/[...path]'

export default Landing
